import { prepareBlogFilterChips } from '../../blogArticleUtilities'
import { defaultInvisibleItemsLength } from '../actions'

function updateFilteredItemsAndSelectedKeysOnBlogFilterChipSelection(
  state,
  action
) {
  const { payload: { searchTopic = '', searchType = '' } = {} } = action
  const { selectedKeys, items = [], selectedSearch = '' } = state
  let combinedKeys = selectedKeys
  if (selectedKeys.includes(searchTopic)) {
    combinedKeys = combinedKeys.filter((item) => {
      return item.toLowerCase() !== searchTopic.toLowerCase()
    })
  } else {
    combinedKeys = searchTopic
      ? [...combinedKeys, searchTopic.toLowerCase()]
      : combinedKeys
  }
  const updatedFilteredItemsBySelectedSearch = selectedSearch
    ? getFilteredItemsListFromSearchText(items, selectedSearch)
    : items
  let updatedFilteredItems = getFilteredItemsListFromKeys(
    combinedKeys,
    updatedFilteredItemsBySelectedSearch
  )
  if (searchType) {
    updatedFilteredItems = getFilteredItemsListFromSearchType(
      searchType,
      updatedFilteredItemsBySelectedSearch
    )
  }
  const itemsVisible =
    updatedFilteredItems.length >= defaultInvisibleItemsLength
      ? defaultInvisibleItemsLength
      : updatedFilteredItems.length

  return {
    ...state,
    filteredItems: updatedFilteredItems,
    selectedKeys: combinedKeys,
    itemsVisible,
  }
}

function updateInitialStateWithFilterItemsAndKeys(state, action) {
  const {
    payload: { documents = [], totalItemsSize = 0, taxonomies = [] },
  } = action
  const blogFilterChips = prepareBlogFilterChips(taxonomies, documents)
  const itemsVisible =
    documents.length >= defaultInvisibleItemsLength
      ? defaultInvisibleItemsLength
      : documents.length

  return {
    ...state,
    blogFilterChips,
    items: documents,
    filteredItems: documents,
    totalItems: totalItemsSize,
    itemsVisible,
  }
}
function getFilteredItemsListFromKeys(selectedKeys = [], items = []) {
  const updatedFilteredItems =
    selectedKeys.length === 0
      ? items
      : items.reduce((filteredItemsAccumulator, item) => {
          const { keys = [] } = item.processedFields
          const addToFilteredList = keys.some((i) => selectedKeys.includes(i))
          if (addToFilteredList) {
            return [...filteredItemsAccumulator, item]
          }
          return filteredItemsAccumulator
        }, [])
  return updatedFilteredItems
}
function getFilteredItemsListFromSearchType(searchType = '', items = []) {
  const searchTypeItems = searchType.toLowerCase().split(',')
  const updatedFilteredItems = items.reduce(
    (filteredItemsAccumulator, item) => {
      const { model: { data: { types = [] } = {} } = {} } = item.document
      const addToFilteredList = types.some((i) =>
        searchTypeItems.includes(i.toLowerCase())
      )
      if (addToFilteredList) {
        return [...filteredItemsAccumulator, item]
      }
      return filteredItemsAccumulator
    },
    []
  )
  return updatedFilteredItems
}
function getFilteredItemsListFromSearchText(items = [], searchText = '') {
  const updatedFilteredItems = items.reduce(
    (filteredItemsAccumulator, item) => {
      const { cardSummary = '', title = '' } = item.document.getData()
      const addToFilteredList =
        title.toLowerCase().indexOf(searchText.toLowerCase()) > -1 ||
        cardSummary.toLowerCase().indexOf(searchText.toLowerCase()) > -1
      if (addToFilteredList) {
        return [...filteredItemsAccumulator, item]
      }
      return filteredItemsAccumulator
    },
    []
  )
  return updatedFilteredItems
}
function updateStateOnSelectedSearch(state, action) {
  const { items = [], selectedKeys = [] } = state
  const updatedFilteredItemsByKeys =
    selectedKeys.length > 0
      ? getFilteredItemsListFromKeys(selectedKeys, items)
      : items
  const updatedFilteredItems = getFilteredItemsListFromSearchText(
    updatedFilteredItemsByKeys,
    action.payload
  )
  const itemsVisible =
    updatedFilteredItems.length >= defaultInvisibleItemsLength
      ? defaultInvisibleItemsLength
      : updatedFilteredItems.length
  return {
    ...state,
    selectedSearch: action.payload,
    filteredItems: updatedFilteredItems,
    itemsVisible,
  }
}

export {
  updateFilteredItemsAndSelectedKeysOnBlogFilterChipSelection,
  updateInitialStateWithFilterItemsAndKeys,
  updateStateOnSelectedSearch,
}
